import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-navigating',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './navigating.component.html',
  styleUrl: './navigating.component.scss'
})
export class NavigatingComponent {

}
